import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { properties } from '../../../../../environments/properties';
import { VehicleModel } from '../../../../model/vehicle.model';
import { RouterLink } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-list-vehicle',
  standalone: true,
  imports: [
    ButtonModule,
    TableModule,
    TooltipModule,
    InputSwitchModule,
    RouterLink,
    DividerModule,
    DialogModule,
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    ConfirmDialogModule,
    IconFieldModule,
    InputIconModule,
    CommonModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list-vehicle.component.html',
  styleUrl: './list-vehicle.component.css',
})
export class ListVehicleComponent implements OnInit {
  ltsVehicle: VehicleModel[] = [];
  loading: boolean = false;
  dialogEdit: boolean = false;

  formVehiculo = new FormGroup({
    veh_plate: new FormControl('', Validators.required),
    veh_num_registration: new FormControl('', Validators.required),
    veh_model: new FormControl('', Validators.required),
    veh_brand: new FormControl('', Validators.required),
    veh_quantity_person: new FormControl('', Validators.required),
    veh_anio: new FormControl('', Validators.required),
    veh_color: new FormControl('', Validators.required),
    veh_inspection: new FormControl(false, Validators.required),
    veh_secure: new FormControl(false, Validators.required),
    veh_id: new FormControl(0, Validators.required),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getListVehicle();
  }

  getListVehicle(): void {
    const body: JsonRequest = {
      data: '',
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.loading = true;
    this.apiService.consumirWSPost(
      properties.serviceGetAllVehicle,
      body,
      (data) => {
        this.ltsVehicle = data.data;
        this.loading = false;
      },
    );
  }

  showDialog(vehicle: VehicleModel) {
    this.dialogEdit = true;
    this.formVehiculo.setValue({
      veh_plate: vehicle.veh_plate,
      veh_num_registration: vehicle.veh_num_registration,
      veh_model: vehicle.veh_model,
      veh_brand: vehicle.veh_brand,
      veh_quantity_person: vehicle.veh_quantity_person.toString(),
      veh_anio: vehicle.veh_anio.toString(),
      veh_color: vehicle.veh_color,
      veh_inspection: vehicle.veh_inspection == 1,
      veh_secure: vehicle.veh_inspection == 1,
      veh_id: vehicle.veh_id,
    });
  }

  save() {
    const body: JsonRequest = {
      data: JSON.stringify({
        veh_plate: this.formVehiculo.get('veh_plate')?.value,
        veh_num_registration: this.formVehiculo.get('veh_num_registration')
          ?.value,
        veh_model: this.formVehiculo.get('veh_model')?.value,
        veh_brand: this.formVehiculo.get('veh_brand')?.value,
        veh_quantity_person: this.formVehiculo.get('veh_quantity_person')
          ?.value,
        veh_anio: this.formVehiculo.get('veh_anio')?.value,
        veh_color: this.formVehiculo.get('veh_color')?.value,
        veh_inspection:
          this.formVehiculo.get('veh_inspection')?.value == true ? 1 : 0,
        veh_secure: this.formVehiculo.get('veh_secure')?.value == true ? 1 : 0,
        veh_id: this.formVehiculo.get('veh_id')?.value,
        veh_status: 1,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };

    this.apiService.consumirWSPost(
      properties.serviceUpdateVehicle,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.util.mostrarToast(
            'Editar vehiculo',
            'Se ha editado el vehículo',
            1,
          );
          this.formVehiculo.reset();
          this.dialogEdit = false;
          this.getListVehicle();
        } else {
          this.util.mostrarToast('Editar vehiculo', 'Error al editar', 4);
        }
      },
    );
  }

  deleteVehicle(event: Event, vehicle: VehicleModel) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Quieres eliminar a este vehiculo?',
      header: 'Eliminar Conductor',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        const body: JsonRequest = {
          data: JSON.stringify(vehicle),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };

        this.apiService.consumirWSPost(
          properties.serviceDeleteVehicle,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Conductor Eliminado',
                'Se ha eliminado el conductor',
                1,
              );
              this.formVehiculo.reset();
              this.dialogEdit = false;
              this.getListVehicle();
            } else {
              this.util.mostrarToast(
                'Conductor Eliminado',
                'Error al eliminar',
                4,
              );
            }
          },
        );
      },
      reject: () => {},
    });
  }

  UnassignVehicle(event: Event, vehicle: VehicleModel) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Quieres quitar el conductor a este vehiculo?',
      header: 'Quitar Conductor',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        const body: JsonRequest = {
          data: JSON.stringify(vehicle),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };

        this.apiService.consumirWSPost(
          properties.serviceUnassignVehicle,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Conductor Quitado',
                'Se ha quitado el conductor',
                1,
              );
              this.formVehiculo.reset();
              this.dialogEdit = false;
              this.getListVehicle();
            } else {
              this.util.mostrarToast('Conductor Quitado', 'Error al quitar', 4);
            }
          },
        );
      },
      reject: () => {},
    });
  }
}
